/**
 * File: TfController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
import textPopup from '../views/editor.html';

class TfController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, uploadService, $mdMedia,$sce) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        /********** BASIC DETAILS *********/
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_TF
        $scope.questionImage = [];
        $scope.explanationImage = [];
        $scope.falseHintImage = [];
        $scope.isLatex = false
        $scope.content_editor_id = userId;
        $scope.isNotComposed = false


        /******* LIMIT FOR QUSTION CREATION *******/
        $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.explain_limit=CQuesConst.ANS_EXPLANATION_LIMIT;
        //SET UI FOR EDIT QUESTIONS
        let editQuestion = $scope.$parent.$parent.editQuestion
        if (editQuestion && editQuestion.choice) {
            $scope._id = editQuestion._id;
            $scope.question = editQuestion.qn_desc;
            $scope.isNotComposed = true
            $scope.questionImg = [];
            if (editQuestion.questionImg) {
                if (Array.isArray(editQuestion.questionImg)) {
                    $scope.questionImage = editQuestion.questionImg
                } else {
                    $scope.questionImage.push(editQuestion.questionImg)
                }
            }
            $scope.answer = _.find(editQuestion.choice, function (ch) {
                return ch.correct
            }).tag;
            let explanation = _.find(editQuestion.choice, function (ch) {
                return ch.correct
            });
            $scope.explanation = explanation.explanation;
            let hint = _.find(editQuestion.choice, function (ch) {
                return !ch.correct
            })
            $scope.falseHint = hint.hint;
            $scope.explanationImage = [];
            if (editQuestion.explanationImage) {
                if (Array.isArray(editQuestion.explanationImage)) {
                    $scope.explanationImage = editQuestion.explanationImage
                } else {
                    $scope.explanationImage.push(editQuestion.explanationImage)
                }
            }
            $scope.falseHintImage = [];
            if (editQuestion.falseHintImage) {
                if (Array.isArray(editQuestion.falseHintImage)) {
                    $scope.falseHintImage = editQuestion.falseHintImage
                } else {
                    $scope.falseHintImage.push(editQuestion.falseHintImage)
                }
            }
            $scope.created_dt = editQuestion.created_dt;
            $scope.content_editor_id = editQuestion.content_editor_id;
            $scope.selectedPassage_id = editQuestion.passage_id;
            if ($scope.selectedPassage_id) {
                $scope.selectedPassage = editQuestion.passage_detail;
            }
        }
        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            $scope.isPassagePresent = false;
            $scope.passages = []
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        $scope.isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage_id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        $scope.passages = result
                    }
                    _.defer(() => { $scope.$apply() })
                }
            }
        }
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)


        //BASIC DETAIL FOR LATEX
        var MQ = MathQuill.getInterface(2);
        //LATEX FOR QUESTION
        var mathFieldSpan = document.getElementById('tf-math-field');
        mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
        if ($scope.question) {
            mathFieldSpan.textContent = $scope.question
        }
        var mathField = MQ.MathField(mathFieldSpan, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function () {
                    $scope.question = mathField.latex()
                }
            }
        });

        //PREVENT PASTE FUNCTIONALITY
        $scope.paste = function (e) {
            e.preventDefault();
            return false
        }

        //Image upload for question
        $scope.questionImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.questionImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }


        //Image upload for Desc
        $scope.falseHintImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.falseHintImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //Image upload for explanation
        $scope.explanationImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.explanationImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function ($scope, $mdDialog, imageViewType, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function (imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function () {
                $mdDialog.cancel();
                if (imageViewType === 'question') {
                    $scope.questionImage = $scope.imageArray
                } else if (imageViewType === 'explan') {
                    $scope.explanationImage = $scope.imageArray
                } else if (imageViewType === 'falseHint') {
                    $scope.falseHintImage = $scope.imageArray
                }
                $scope.imageArray = []
            };
        }
        $scope.cancelSelectedPasssage = function () {

            $scope.selectedPassage = null
            _.each($scope.passages, function (eachPas) {
                eachPas.isSelected = false
            })
        }
        //Open dialog to view image
        $scope.openDialog = (imageType) => {
            let imageDetails;
            if (imageType === 'question') {
                imageDetails = {
                    title: "TF - Question Image",
                    images: $scope.questionImage
                }
            } else if (imageType === 'explan') {
                imageDetails = {
                    title: "TF - Explanation Image",
                    images: $scope.explanationImage
                }
            } else if (imageType === 'falseHint') {
                imageDetails = {
                    title: "TF - False Hint Image",
                    images: $scope.falseHintImage
                }
            }
            else if (imageType === 'passage') {
                imageDetails = {
                    title: "TF - Passage Image",
                    images: $scope.selectedPassage.passage_image,
                    isPassage: true
                }
            }
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    imageViewType: imageType,
                    imageDetails: imageDetails
                },
                template: imagePopup,
                controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        var setPassage = () => {
            $scope.selectedPassage = _.find($scope.passages, function (pas) {
                return pas.isSelected
            })
        }

        //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function ($scope, $mdDialog, passages) {
            $scope.passages = passages
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
                setPassage()
            };



            /*
           * Function to select passage
           */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                    if (eachPas._id != passage_id) {
                        eachPas.isSelected = false;
                    }
                })
                $scope.cancelPassage()
            }

        }


        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            if (!$scope.passages) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No Passage')
                        .textContent('Passages not loaded.Try after some time.')
                        .ariaLabel('Passage Dialog')
                        .ok('Ok')
                );
            }
            else {
                if ($scope.passages.length == 0) {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No Passage')
                            .textContent('No passages added yet. Please add passage and link it')
                            .ariaLabel('Passage Dialog')
                            .ok('Ok')
                    );
                }


                else {
                    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                    $mdDialog.show({
                        locals: {
                            passages: $scope.passages
                        },
                        template: passagePopup,
                        controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: useFullScreen
                    })
                }
            }
        }
        //Adding OWQ question from UI
        $scope.$on('addTfQuestion', function () {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            //[Object] - to push correct and wrong answer object
            let choice = []

            //Object - correct answer
            let correctObj = {};

            //Object - wrong answer
            let wrongObj = {};
            if ($scope.answer === "True") {
                correctObj.tag = "True"
                wrongObj.tag = "False"
            } else {
                correctObj.tag = "False"
                wrongObj.tag = "True"
            }
            correctObj.explanation = $scope.explanation;
            correctObj.correct = true;
            correctObj.explanationImage = $scope.tf.explanationImage;
            choice.push(correctObj);
            wrongObj.hint = $scope.falseHint;
            wrongObj.correct = false;
            wrongObj.falseHintImage = $scope.tf.falseHintImage;
            choice.push(wrongObj);
            $scope.errors = {}

            //Validation  
            if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
                $scope.errors.question = "Question is required";
                activityErrorCount++;
            } else if ($scope.question.length > $scope.ques_desc_limit) {
                $scope.errors.question = "Question does not exceed " + $scope.ques_desc_limit + " characters";
                activityErrorCount++;
            }
            if ($scope.isPractice) {
                if ($scope.explanation == null || $scope.explanation == undefined || $scope.explanation == "") {
                    $scope.errors["explanation"] = "Explanation is required"
                    activityErrorCount++;
                }
                if ($scope.falseHint == null || $scope.falseHint == undefined || $scope.falseHint == "") {
                    $scope.errors["falseHint"] = "False hint is required"
                    activityErrorCount++;
                }
            }
            if ($scope.explanation && $scope.explanation.length > $scope.explain_limit) {
                $scope.errors["explanation"] = "Explanation does not exceed " + $scope.explain_limit + " characters";
                activityErrorCount++;
            }
            if ($scope.falseHint && $scope.falseHint.length > $scope.explain_limit) {
                $scope.errors["falseHint"] = "False does not exceed " + $scope.explain_limit + " characters";
                activityErrorCount++;
            }
            if ($scope.answer == null || $scope.answer == undefined || $scope.answer == "") {
                $scope.errors["answer"] = "Answer is required"
                activityErrorCount++;
            } else if ($scope.answer.length > $scope.option_limit) {
                $scope.errors["answer"] = "Answer does not exceed " + $scope.option_limit + " characters";
               activityErrorCount++;
            }
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                let obj = {
                    "_id": $scope._id,
                    "question_theme_id": question.theme._id,
                    "question_theme_name": question.theme.name,
                    "choice": choice,
                    "explanationImage": $scope.explanationImage,
                    "falseHintImage": $scope.falseHintImage,
                    "strand": question.strand,
                    "tag": question.tag,
                    "wave": question.wave,
                    "qn_desc": '' + $scope.question,
                    "isLatex": $scope.isLatex,
                    "level": question.level,
                    "subject_id": question.subject_id,
                    "school_id": question.school_id,
                    "questionImg": $scope.questionImage,
                    "session_id": question.session_id,
                    "batch_id": question.batch_id,
                    "class_id": question.class_id,
                    "curriculum_id": question.curriculum_id,
                    "xlink": question.link_theme,
                    "cognitive_skills": question.cognitive_skill,
                    "isNotAddToQp": question.isNotAddToQp,
                    "is_traditional_activity": question.is_traditional_activity,
                    "qp_id": question.qp_id,
                    "activity_id": question.activity_id,
                    "user_id": userId,
                    "created_dt": $scope.created_dt,
                    "content_editor_id": $scope.content_editor_id,
                    "passage": $scope.selectedPassage,
                    "teaching_plan_id": question.teaching_plan_id
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (question.is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: question.qp_id
                            })
                            toastr.success("Question Saved successfully");
                        }else if(question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== ""){
                            $state.go('formatQp', {
                                resourceId: question.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })



        $scope.viewTextAngular = function () {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
                locals: {
                    parentScope : $scope
                },
                template: textPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
            
        }
        $scope.setQuestionFromEditor = function (editor_value){
            $scope.question = editor_value
            $scope.used_editor = true
            $scope.isNotComposed = true
            let used_editor = document.getElementById('used_editor')
            $scope.used_editor_html = $sce.trustAsHtml(editor_value);
            // used_editor.append(editor_value)
            console.log(used_editor)
        }
        function resetFn(){
            $scope.isNotComposed = false
            $scope.question = ''
            $scope.used_editor_html = ''
        }
        $scope.resetQuestion = function (){
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('This will remove question from the input, If you want to edit use editor')
                .ariaLabel('Lucky day')
                .ok('Remove')
                .cancel('Dont delete');

            $mdDialog.show(confirm).then(function() {
                resetFn()
            }, function(f, r) {
            });
        }
    }
}


class editorLACtrl {
    constructor($scope, $mdDialog, parentScope) {
        Simditor.locale = 'en-US';
        var editor = undefined
        angular.element(document).ready(function () {
            $scope.editor = {}
            editor = new Simditor({
                textarea: $('#editor'),
                placeholder: '',
                params: {},
                upload: false,
                tabIndent: true,
                toolbar: [
                    'title',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'fontScale',
                    'color',
                    'ol' ,      
                    'ul'  ,          
                    'blockquote',
                    'code',         
                    'table',
                    'link',
                    // 'image',
                    'hr',           
                    'indent',
                    'outdent',
                    'alignment'
                ],
                toolbarFloat: true,
                toolbarFloatOffset: 0,
                toolbarHidden: false,
                pasteImage: false,
                cleanPaste: false,
                codeLanguages : [{ name: 'Erlang', value: 'erlang' },]
                //optional options
            });
            if(parentScope.question){
                editor.setValue(parentScope.question)
            }
        });
        $scope.saveContent = (desc) => {
            console.log(desc)
            console.log($scope.editor)
            let editor_value = editor.getValue()
            if(!editor_value){
                toastr.error("Please enter question")
                return false
            }
            parentScope.setQuestionFromEditor(editor_value)
            $mdDialog.hide();
        }
        $scope.closeEditor = () => {
            $mdDialog.hide();
        }
    }
}

export default TfController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/tfController.js